import Immutable from 'immutable';
import { createReducer } from '../utils';
import * as actionTypes from '../actionTypes/searchAlertsActionTypes';

const initialState = Immutable.fromJS({
  alerts: [],
  error: null,
  isLoading: false,
});

export const automatedReports = createReducer(initialState, {
  [actionTypes.AUTOMATED_REPORTS.REQUEST]: state =>
    state.merge(Immutable.fromJS({
      isLoading: true,
    })),
  [actionTypes.AUTOMATED_REPORTS.SUCCESS]: (state, { data }) =>
    state.merge(Immutable.fromJS({
      alerts: data.alerts,
      isLoading: false,
    })),
  [actionTypes.AUTOMATED_REPORTS.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
      isLoading: false,
    })),

  [actionTypes.REMOVE_AUTOMATED_REPORT.REQUEST]: (state, { data }) => {
    const alerts = state.get('alerts').map(alert => (
      alert.set('isBeingRemoved', alert.get('rtalert_cron_id') === data.id)
    ));

    return state.set('alerts', alerts);
  },
  [actionTypes.REMOVE_AUTOMATED_REPORT.SUCCESS]: state => state,
  [actionTypes.REMOVE_AUTOMATED_REPORT.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
    })),
});

export const templateAlerts = createReducer(initialState, {
  [actionTypes.TEMPLATE_ALERTS.REQUEST]: state =>
    state.merge(Immutable.fromJS({
      isLoading: true,
    })),
  [actionTypes.TEMPLATE_ALERTS.SUCCESS]: (state, { data }) =>
    state.merge(Immutable.fromJS({
      alerts: data,
      isLoading: false,
    })),
  [actionTypes.TEMPLATE_ALERTS.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
      isLoading: false,
    })),

  [actionTypes.UPDATE_TEMPLATE_ALERT.REQUEST]: (state, { payload: { index, name } }) =>
    state.setIn(['alerts', index, 'isUpdating', name], true),
  [actionTypes.UPDATE_TEMPLATE_ALERT.SUCCESS]: (state, { payload: { index, name, value } }) =>
    state
      .setIn(['alerts', index, name], value)
      .setIn(['alerts', index, 'isUpdating', name], false),
  [actionTypes.UPDATE_TEMPLATE_ALERT.ERROR]: (state, { error, payload: { index, name } }) =>
    state
      .merge(Immutable.fromJS({ error }))
      .setIn(['alerts', index, 'isUpdating', name], false),

  [actionTypes.RESEND_TEMPLATE_ALERT.REQUEST]: (state, { payload: { index } }) =>
    state.setIn(['alerts', index, 'isBeingResent'], true),
  [actionTypes.RESEND_TEMPLATE_ALERT.SUCCESS]: (state, { payload: { index } }) =>
    state
      .setIn(['alerts', index, 'isBeingResent'], false)
      .setIn(['alerts', index, 'resend'], true),
  [actionTypes.RESEND_TEMPLATE_ALERT.ERROR]: (state, { error, payload: { index } }) =>
    state
      .merge(Immutable.fromJS({ error }))
      .setIn(['alerts', index, 'isBeingResent'], false),
});

const customAlertsInitialState = initialState.merge(Immutable.fromJS({
  deliveryLog: [],
  deliveryLogLoading: false,
  deliveryLogError: null,
}));

export const customAlerts = createReducer(customAlertsInitialState, {
  [actionTypes.CUSTOM_ALERTS.REQUEST]: state =>
    state.merge(Immutable.fromJS({
      isLoading: true,
    })),
  [actionTypes.CUSTOM_ALERTS.SUCCESS]: (state, { data }) =>
    state.merge(Immutable.fromJS({
      alerts: data,
      isLoading: false,
    })),
  [actionTypes.CUSTOM_ALERTS.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      error,
      isLoading: false,
    })),

  [actionTypes.UPDATE_CUSTOM_ALERT.REQUEST]: (state, { payload: { index } }) =>
    state.setIn(['alerts', index, 'isUpdating'], true),
  [actionTypes.UPDATE_CUSTOM_ALERT.SUCCESS]: (state, { payload: { index, alert } }) =>
    state.setIn(['alerts', index], Immutable.fromJS(alert)),
  // .setIn(['alerts', index, 'isUpdating'], false),
  [actionTypes.UPDATE_CUSTOM_ALERT.ERROR]: (state, { error, payload: { index } }) =>
    state
      .merge(Immutable.fromJS({ error }))
      .setIn(['alerts', index, 'isUpdating'], false),

  [actionTypes.REMOVE_CUSTOM_ALERT.REQUEST]: (state, { payload: { index } }) =>
    state.setIn(['alerts', index, 'isBeingRemoved'], true),
  [actionTypes.REMOVE_CUSTOM_ALERT.SUCCESS]: (state, { payload: { index } }) =>
    state.deleteIn(['alerts', index]),
  [actionTypes.REMOVE_CUSTOM_ALERT.ERROR]: (state, { error, payload: { index } }) =>
    state
      .merge(Immutable.fromJS({ error }))
      .setIn(['alerts', index, 'isBeingRemoved'], false),

  [actionTypes.RESEND_CUSTOM_ALERT.REQUEST]: (state, { payload: { index } }) =>
    state.setIn(['alerts', index, 'isBeingResent'], true),
  [actionTypes.RESEND_CUSTOM_ALERT.SUCCESS]: (state, { payload: { index } }) =>
    state
      .setIn(['alerts', index, 'isBeingResent'], false)
      .setIn(['alerts', index, 'resend'], true),
  [actionTypes.RESEND_CUSTOM_ALERT.ERROR]: (state, { error, payload: { index } }) =>
    state
      .merge(Immutable.fromJS({ error }))
      .setIn(['alerts', index, 'isBeingResent'], false),

  [actionTypes.DELIVERY_LOG.REQUEST]: state =>
    state.merge(Immutable.fromJS({
      deliveryLog: [],
      deliveryLogLoading: true,
      deliveryLogError: null,
    })),
  [actionTypes.DELIVERY_LOG.SUCCESS]: (state, { data }) =>
    state.merge(Immutable.fromJS({
      deliveryLog: data,
      deliveryLogLoading: false,
      deliveryLogError: null,
    })),
  [actionTypes.DELIVERY_LOG.ERROR]: (state, { error }) =>
    state.merge(Immutable.fromJS({
      deliveryLog: [],
      deliveryLogLoading: false,
      deliveryLogError: error,
    })),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/searchAlertsReducer.js